import { render, staticRenderFns } from "./CatalogDetail.vue?vue&type=template&id=df7403c8&scoped=true&"
import script from "./CatalogDetail.vue?vue&type=script&lang=ts&"
export * from "./CatalogDetail.vue?vue&type=script&lang=ts&"
import style0 from "./CatalogDetail.vue?vue&type=style&index=0&id=df7403c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df7403c8",
  null
  
)

export default component.exports